import React from 'react';
import styled from '@emotion/styled';
import { Only } from 'ui/components/elements/Only/Only';
import ImgSp01 from 'ui/images/top/topInterview_img01_sp@2x.png';
import ImgPc01 from 'ui/images/top/topInterview_img01_pc@2x.png';
import LineImgPc01 from 'ui/images/top/topInterview_line_pc.svg';
import LineImgSp01 from 'ui/images/top/topInterview_line_sp.svg';
import LineSvgPc01 from 'ui/images/top/topInterview_line_pc.svg';
import LineImg02 from 'ui/images/top/topInterview_img02@2x.png';
import LineImg03 from 'ui/images/top/topInterview_img03@2x.png';
import LineImg04 from 'ui/images/top/topInterview_img04@2x.png';
import { mqMin } from 'utils/responsive';

const Container = styled.section`
    background-color: var(--dark-blue);
    padding: 67px 0 40px 0;
    position: relative;

    &::before {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-color: transparent transparent var(--dark-blue) transparent;
        border-width: 0px 19px 23px 19px;
        margin: 0 auto 0 auto;
        position: absolute;
        top: -19px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
    }

    ${mqMin('NARROW')} {
        padding: 79px 0 43px 0;
    }
`;

const H2 = styled.h2`
    text-align: center;
    color: #fff;
    font-size: min(6.3vw, 24px);
    line-height: 1.5em;
    letter-spacing: 0.05em;
    margin-bottom: 48px;

    strong {
        font-size: min(6.6vw, 28px);
    }

    ${mqMin('NARROW')} {
        font-size: 1.125rem;
        margin-bottom: 43px;

        strong {
            font-size: 1.6rem;
        }
    }
`;

const QTextContainer = styled.div`
    ${mqMin('NARROW')} {
        width: 385px;
        position: relative;
        margin: 0 auto 0 auto;
        z-index: 2;
    }
`;

const QContent = styled.div`
    display: flex;
    align-items: center;
    width: 88.37209302325581%;
    max-width: 380px;
    border-radius: 11px;
    background-color: var(--white);
    padding: 28px;
    margin: 0 auto 0 auto;

    ${mqMin('SP')} {
        width: 35rem;
        max-width: initial;
    }

    ${mqMin('NARROW')} {
        align-items: flex-start;
        width: initial;
        max-width: initial;
        padding: 25px;
    }
`;

const ImgQWrapper = styled.div`
    width: 212px;
    margin: -20px auto 0 auto;

    ${mqMin('NARROW')} {
        position: absolute;
        top: 0;
        right: -100px;
        top: -10px;
        width: 142px;
        margin: initial;
    }
`;

const ImgAWrapper = styled.div`
    width: 86px;
    height: 105px;
    margin: -36px auto 0 auto;

    ${mqMin('NARROW')} {
        margin: -20px auto 0 auto;
    }
`;

const MarkContainer = styled.div`
    font-size: 1.75rem; /*28px*/
    line-height: 1.6em;
    letter-spacing: 0.1em;
    margin-right: 13px;

    ${mqMin('NARROW')} {
        font-size: 2rem;
        line-height: 1em;
        margin-right: 11px;
    }
`;

const InterviewContentText = styled.div`
    line-height: 1.5em;
    font-size: 0.7rem;
    letter-spacing: 0.1em;

    ${mqMin('SP')} {
        font-size: 1.4rem;
    }
    ${mqMin('NARROW')} {
        font-size: 0.8rem;
    }
`;

const InterviewContentLine = styled.div`
    width: 2px;
    height: 51px;
    margin: 25px auto;

    ${mqMin('NARROW')} {
        width: 556px;
        height: 80px;
        margin: 0 auto 0 auto;
    }
`;

const InterviewImg = styled.img`
    width: 100%;
    margin-bottom: 5px;
`;

const LinkWrapper = styled.div`
    ${mqMin('NARROW')} {
        display: flex;
        justify-content: space-between;
        width: 87.84722222222222%;
        max-width: 1265px;
        margin: 0 auto 0 auto;
    }
`;

const LinkItem = styled.div`
    padding-bottom: 55px;

    ${mqMin('NARROW')} {
        margin: 0 10px;
    }
`;

const QLinkContent = styled.div`
    display: flex;
    align-items: center;
    width: 88.37209302325581%;
    max-width: 380px;
    border-radius: 11px;
    background-color: var(--white);
    padding: 28px;
    margin: 0 auto 0 auto;

    ${mqMin('SP')} {
        width: 35rem;
        max-width: initial;
    }

    ${mqMin('NARROW')} {
        align-items: flex-start;
        width: initial;
        max-width: initial;
        padding: 30px 28px;
    }
`;

const CompanyName = styled.div`
    text-align: center;
    color: #fff;
    font-size: 0.875rem; /*14px*/
`;

export const Interview: React.FC = () => {
    return (
        <Container>
            <H2 className="fadein fadein_y">
                MAnyでは、マイページ上で
                <Only sp>
                    <br />
                </Only>
                <strong>複数社と</strong>
                <Only sp>
                    <br />
                </Only>
                <strong>質問・相談・面談</strong>ができます。
            </H2>
            <QTextContainer className="fadein fadein_y">
                <QContent>
                    <MarkContainer>Q.</MarkContainer>
                    <InterviewContentText>
                        成功報酬はいくらでしょうか？
                        <br />
                        また、専任の担当はつきますか？
                    </InterviewContentText>
                </QContent>
                <ImgQWrapper>
                    <picture>
                        <source media="(max-width: 1023px)" srcSet={ImgSp01} />
                        <source media="(min-width: 1024px)" srcSet={ImgPc01} />
                        <InterviewImg src={ImgPc01} alt="Qのイメージ" />
                    </picture>
                </ImgQWrapper>
            </QTextContainer>
            <InterviewContentLine className="fadein fadein_y">
                <picture>
                    <source media="(max-width: 1023px)" srcSet={LineImgSp01} />
                    <source media="(min-width: 1024px)" srcSet={LineImgPc01} />
                    <img src={LineSvgPc01} alt="" />
                </picture>
            </InterviewContentLine>
            <LinkWrapper>
                <LinkItem className="fadein fadein_y">
                    <QLinkContent>
                        <MarkContainer>A.</MarkContainer>
                        <InterviewContentText>
                            最低報酬1500万円からです。
                            <Only pc>
                                <br />
                            </Only>
                            専属の担当がつき、早期の成約を目指します。
                            <Only pc>
                                <br />
                            </Only>
                            2年以内の成約率が高いのが強みです。
                        </InterviewContentText>
                    </QLinkContent>
                    <ImgAWrapper>
                        <InterviewImg src={LineImg02} alt="" />
                        <CompanyName>A社</CompanyName>
                    </ImgAWrapper>
                </LinkItem>
                <LinkItem className="fadein fadein_y">
                    <QLinkContent>
                        <MarkContainer>A.</MarkContainer>
                        <InterviewContentText>
                            最低報酬は2000万円からです。
                            <Only pc>
                                <br />
                            </Only>
                            専属の担当が2名つき、お客様をしっかりとサポートいたします。
                            <Only pc>
                                <br />
                            </Only>
                            手厚いサポート力が強みです。
                        </InterviewContentText>
                    </QLinkContent>
                    <ImgAWrapper>
                        <InterviewImg src={LineImg03} alt="" />
                        <CompanyName>B社</CompanyName>
                    </ImgAWrapper>
                </LinkItem>
                <LinkItem className="fadein fadein_y">
                    <QLinkContent>
                        <MarkContainer>A.</MarkContainer>
                        <InterviewContentText>
                            最低報酬は500万円からです。
                            <Only pc>
                                <br />
                            </Only>
                            特定の担当ではなく、チームでサポートさせていただきます。
                            <Only pc>
                                <br />
                            </Only>
                            小規模のお客様でも負担が少ないよう、低価格が強みです。
                        </InterviewContentText>
                    </QLinkContent>
                    <ImgAWrapper>
                        <InterviewImg src={LineImg04} alt="" />
                        <CompanyName>C社</CompanyName>
                    </ImgAWrapper>
                </LinkItem>
            </LinkWrapper>
        </Container>
    );
};
